export default "__VITE_ASSET__c86810f8__"